import React from 'react'

function KOTSingle({data, orders}) {
    return (
        <div className="flex justify-center my-4">
            <div className="w-full px-8">
              <div className="text-center mb-6">
                <h2 className="text-xl font-bold">KOT</h2>
                <p className="font-semibold">Order No: {Number(data?.token_no)}</p>
              </div>
    
              <div className="text-sm mb-4 text-center">
                <p>
                  <strong>Invoice No:</strong> {data?.sale_no}
                </p>
                <p>
                  <strong>Date:</strong> {data?.date_time}
                </p>
                <p>
                  <strong>Customer:</strong> {data.customer?.name}
                </p>
                <p>
                  <strong>Order Type:</strong> {data.order_type?.type}
                </p>
              </div>
    
              <div className="mb-2">
                <div className="grid grid-cols-3 border-b border-gray-500 font-semibold">
                  <span className="mx-1">SN</span>
                  <span className="mx-1">Item</span>
                  <span className="mx-1 text-end">Qty</span>
                </div>
              </div>
    
              <div className="mb-2">
                {orders?.map((order, index) => (
                  <div className=" border-b border-gray-300 py-2 space-y-2">
                    <div key={index} className="grid grid-cols-3">
                      <span className="mx-1">{index + 1}</span>
                      <span className="mx-1">{order.food_menu.name}</span>
                      <span className="mx-1 text-end">{order.qty}</span>
                    </div>
                    {order.selected_modifiers?.map((mod, index) => (
                      <div key={index}>
                        <p>{mod.name}</p>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
    
              <div className="mt-4">
                <p className="text-center font-semibold">
                  Total Item(s): {data?.total_items}
                </p>
              </div>
          </div>
        </div>
      );
}

export default KOTSingle